import React, { Component } from "react";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";
import { withRouter } from "react-router-dom";
import Countdown from "react-countdown";
import {
  sendSmsForgotPassword,
  resetPasswordsWitSms,
  selectPassword,
  hideSmsModal,
} from "../../../state/ducks/password/index";
import { alertActions } from "../../../state/ducks/alert/actions";

const PASSWORD_RULES = [
  "Şifreniz en az 8 karakter olmalıdır.",
  "Şifrenizde en az bir tane küçük harf olmalıdır.",
  "Şifrenizde en az bir tane büyük harf olmalıdır.",
  "Şifrenizde en az bir tane rakam bulunmalıdır.",
  "Şifrenizde en az bir özel karakter (!@#$%^&*(),.?:|<>-_) bulunmalıdır.",
];

class SmsVerification extends Component {
  state = {
    newPassword: "",
    reNewPassword: "",
    smsCode: "",
    timerExpired: false,
    resendEnabled: false,
    showNewPassword: false,
    showReNewPassword: false,
  };

  componentDidMount() {
    this.syncTimerState();
  }

  componentDidUpdate(prevProps) {
    const { password } = this.props;

    if (password?.countDate !== prevProps.password?.countDate) {
      this.setState({
        smsCode: "",
        newPassword: "",
        reNewPassword: "",
        timerExpired: false,
        resendEnabled: false,
      });
      this.syncTimerState();
    }

    if (password?.success && !prevProps.password?.success) {
      if (this.redirectTimer) {
        window.clearTimeout(this.redirectTimer);
      }

      this.redirectTimer = window.setTimeout(() => {
        this.props.hideSmsModal();
        this.props.history.push("/giris");
      }, 3500);
    }
  }

  componentWillUnmount() {
    if (this.redirectTimer) {
      window.clearTimeout(this.redirectTimer);
    }
  }

  syncTimerState = () => {
    const { password } = this.props;
    if (!password?.countDate) {
      return;
    }

    const expired = password.countDate + 180000 < Date.now();
    this.setState({
      timerExpired: expired,
      resendEnabled: expired,
    });
  };

  timerEnd = () => {
    this.setState({ timerExpired: true, resendEnabled: true });
  };

  timerStart = () => {
    this.syncTimerState();
  };

  handleClose = () => {
    this.props.hideSmsModal();
    this.setState({
      smsCode: "",
      newPassword: "",
      reNewPassword: "",
      timerExpired: false,
      resendEnabled: false,
      showNewPassword: false,
      showReNewPassword: false,
    });
  };

  resetCounter = (verifyType) => {
    const { password } = this.props;

    this.props.sendSmsForgotPassword({
      kartId: password.response?.data?.kartId?.toString(),
      kartUyelikId: password.response?.data?.kartUyelikId?.toString(),
      kimlikNo: password.kimlikNo,
      uyeNo: password.uyeNo,
      dogumTarihi: password.dogumTarihi,
      verifyType,
    });
  };

  validatePassword = () => {
    const { newPassword, reNewPassword, smsCode } = this.state;
    const { showError } = this.props;

    if (!newPassword) {
      showError("Yeni şifre alanını boş bırakılamaz");
      return false;
    }

    if (newPassword !== reNewPassword) {
      showError("Yeni şifreleriniz aynı olmalıdır.");
      return false;
    }

    if (newPassword.length < 8) {
      showError("Yeni şifreleriniz en az 8 karakter olmalıdır.");
      return false;
    }

    if (newPassword.search(/[a-z]/) < 0) {
      showError("Yeni şifrelerinizde küçük harf bulunmalıdır");
      return false;
    }

    if (newPassword.search(/[A-Z]/) < 0) {
      showError("Yeni şifrelerinizde büyük harf bulunmalıdır");
      return false;
    }

    if (newPassword.search(/[0-9]/) < 0) {
      showError("Yeni şifreleriniz rakam içermelidir.");
      return false;
    }

    if (newPassword.search(/[!@#$%^&*(_),.?:|<>-]/) < 0) {
      showError("Yeni şifrelerinizde en az bir özel karakter (!@#$%^&*(_),.?:|<>-) bulunmalıdır.");
      return false;
    }

    if (!smsCode) {
      showError("Doğrulama kodu alanını boş bırakılamaz");
      return false;
    }

    return true;
  };

  resetPasswordsWitSms = (event) => {
    event.preventDefault();

    if (!this.validatePassword()) {
      return;
    }

    const { password } = this.props;
    const { newPassword, smsCode } = this.state;

    this.props.resetPasswordsWitSms({
      kartId: password?.response?.data?.kartId?.toString(),
      kartUyelikId: password?.response?.data?.kartUyelikId?.toString(),
      kimlikNo: password.kimlikNo,
      newPassword,
      oldPassword: smsCode,
    });
  };

  togglePasswordVisibility = (field) => {
    this.setState((prev) => ({
      [field]: !prev[field],
    }));
  };

  getContactMessage = (isEmail) => {
    const { password } = this.props;
    const phone = password?.response?.data?.telefon;
    const email = password?.response?.data?.eposta || password?.response?.data?.email;

    if (isEmail) {
      return email
        ? `${email} e-posta adresinize gönderilen doğrulama kodunu girin ve yeni şifrenizi oluşturun.`
        : "E-posta adresinize gönderilen doğrulama kodunu girin ve yeni şifrenizi oluşturun.";
    }

    return phone
      ? `${phone} numaralı telefonunuza gelen kodu girin ve yeni şifrenizi oluşturun.`
      : "Telefonunuza gelen doğrulama kodunu girin ve yeni şifrenizi oluşturun.";
  };

  renderPasswordField = ({
    id,
    label,
    value,
    onChange,
    showPassword,
    toggleField,
    disabled,
    placeholder,
  }) => (
    <div className="t-loginPage-field">
      <label className="t-loginPage-label" htmlFor={id}>
        {label}
      </label>
      <div className="t-resetPassword-inputWrap">
        <span className="t-resetPassword-inputIcon">
          <i className="t-icon-lock1" aria-hidden="true" />
        </span>
        <input
          id={id}
          type={showPassword ? "text" : "password"}
          autoComplete="new-password"
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={onChange}
        />
        <span className="t-resetPassword-inputIcon">
          <button
            type="button"
            className="t-loginPage-passwordToggle"
            onClick={() => this.togglePasswordVisibility(toggleField)}
            aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
          >
            <i className={showPassword ? "t-icon-eye" : "t-icon-eye-blocked"} aria-hidden="true" />
          </button>
        </span>
      </div>
    </div>
  );

  renderResetForm = (isEmail) => {
    const { password } = this.props;
    const {
      smsCode,
      newPassword,
      reNewPassword,
      timerExpired,
      resendEnabled,
      showNewPassword,
      showReNewPassword,
    } = this.state;
    const isDisabled = timerExpired || password?.success;
    const codeLabel = isEmail ? "E-posta Doğrulama Kodu" : "SMS Kodu";
    const codePlaceholder = isEmail ? "E-posta doğrulama kodunu giriniz" : "SMS kodunu giriniz";

    return (
      <div className="t-loginPage-verify t-loginPage-reset">
        <header className="t-loginPage-head t-loginPage-head--verify">
          <span className="t-loginPage-forgotIcon" aria-hidden="true">
            <i className="t-icon-lock1" />
          </span>
          <h1 className="t-loginPage-title">Şifre Yenileme</h1>
          <p className="t-loginPage-subtitle">
            {isEmail ? "E-posta doğrulama kodunu girerek yeni şifrenizi belirleyin." : "SMS doğrulama kodunu girerek yeni şifrenizi belirleyin."}
          </p>
        </header>

        {password?.success ? (
          <div className="t-loginPage-success">
            <i className="t-icon-check_circle" aria-hidden="true" />
            <div>Şifreniz başarıyla değiştirilmiştir. Giriş ekranına yönlendiriliyorsunuz...</div>
          </div>
        ) : (
          <>
            <div className="t-loginPage-verifyMessage">{this.getContactMessage(isEmail)}</div>

            <form onSubmit={this.resetPasswordsWitSms} className="t-loginPage-form">
              <div className="t-loginPage-field">
                <label className="t-loginPage-label" htmlFor="forgotVerifyCode">
                  {codeLabel}
                </label>
                <div className="t-resetPassword-inputWrap">
                  <span className="t-resetPassword-inputIcon">
                    <i className="t-icon-phonelink_lock" aria-hidden="true" />
                  </span>
                  <NumberFormat
                    id="forgotVerifyCode"
                    displayType="input"
                    maxLength={6}
                    className="smsdecimalnumber"
                    placeholder={codePlaceholder}
                    value={smsCode}
                    disabled={isDisabled}
                    onChange={(e) => this.setState({ smsCode: e.target.value })}
                    required
                    autoComplete="one-time-code"
                  />
                </div>
              </div>

              {this.renderPasswordField({
                id: "forgotNewPassword",
                label: "Yeni Şifreniz",
                value: newPassword,
                onChange: (e) => this.setState({ newPassword: e.target.value }),
                showPassword: showNewPassword,
                toggleField: "showNewPassword",
                disabled: isDisabled,
                placeholder: "Yeni şifrenizi giriniz",
              })}

              {this.renderPasswordField({
                id: "forgotNewPasswordConfirm",
                label: "Yeni Şifreniz Tekrar",
                value: reNewPassword,
                onChange: (e) => this.setState({ reNewPassword: e.target.value }),
                showPassword: showReNewPassword,
                toggleField: "showReNewPassword",
                disabled: isDisabled,
                placeholder: "Yeni şifrenizi tekrar giriniz",
              })}

              <div className="t-loginPage-verifyTimer" aria-live="polite">
                <i className="t-icon-clock" aria-hidden="true" />
                <span>Kalan süre:</span>
                <Countdown
                  key={password?.countDate}
                  date={password?.countDate + 180000}
                  renderer={(props) => (
                    <strong>{Math.max(0, Math.ceil(props.total / 1000))} sn</strong>
                  )}
                  onStart={this.timerStart}
                  onComplete={this.timerEnd}
                />
              </div>

              <div className="t-loginPage-verifyActions">
                <button type="button" className="t-loginPage-backBtn" onClick={this.handleClose}>
                  <i className="t-icon-arrow-left2" aria-hidden="true" />
                  Geri Dön
                </button>
                <button
                  type="button"
                  className="t-loginPage-verifyResend"
                  disabled={!resendEnabled}
                  onClick={() => this.resetCounter(isEmail ? 2 : 1)}
                >
                  <i className="t-icon-loop2" aria-hidden="true" />
                  Tekrar Gönder
                </button>
                <button type="submit" className="t-loginPage-submit" disabled={isDisabled}>
                  Onayla
                  <i className="t-icon-arrow-right2" aria-hidden="true" />
                </button>
              </div>
            </form>

            {!isEmail ? (
              <button type="button" className="t-loginPage-verifyAltLink" onClick={() => this.resetCounter(2)}>
                Doğrulama kodunu alamadınız mı? <span>E-posta ile doğrulayın.</span>
              </button>
            ) : null}

            <div className="t-loginPage-resetRules">
              <strong>Şifre Değiştirme Kuralları</strong>
              <ol>
                {PASSWORD_RULES.map((rule) => (
                  <li key={rule}>{rule}</li>
                ))}
              </ol>
            </div>
          </>
        )}
      </div>
    );
  };

  render() {
    const { password } = this.props;

    if (password?.isOpenEposta) {
      return this.renderResetForm(true);
    }

    if (password?.isOpen) {
      return this.renderResetForm(false);
    }

    return null;
  }
}

const mapStateToProps = (state) => ({
  password: selectPassword(state),
});

const mapDispatchToProps = (dispatch) => ({
  resetPasswordsWitSms: (data) => dispatch(resetPasswordsWitSms(data)),
  sendSmsForgotPassword: (data) => dispatch(sendSmsForgotPassword(data)),
  hideSmsModal: () => dispatch(hideSmsModal()),
  showError: (message) => dispatch(alertActions.showError(message)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SmsVerification));
